import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const KINDS = [["starts", "Starts with"], ["ends", "Ends with"], ["contains", "Contains"]];

export const CleanupRules = ({ onChange }) => {
  const [rules, setRules] = useState([]);
  const [kind, setKind] = useState("ends");
  const [value, setValue] = useState("");
  const load = () => api.get("/admin/test-accounts/rules").then((r) => setRules(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/test-accounts/rules", { kind, value: value.trim() }); setValue(""); load(); onChange(); toast.success("Rule added"); }
    catch (err) { toast.error(errMsg(err, "Could not add rule")); }
  };
  const remove = async (id) => {
    try { await api.delete(`/admin/test-accounts/rules/${id}`); load(); onChange(); } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="mt-4" data-testid="admin-cleanup-rules">
      <div className="text-xs font-semibold text-mm-muted mb-2">Test email rules</div>
      <div className="flex flex-wrap gap-1.5">
        {rules.map((r) => (
          <span key={r.id || r.label} className="mm-chip !cursor-default !py-1 !px-2.5 !text-[11px] inline-flex items-center gap-1" data-testid={`admin-cleanup-rule-${r.id || r.value}`}>
            {r.label}
            {!r.builtin && <button onClick={() => remove(r.id)} aria-label={`Remove rule ${r.label}`} className="hover:text-mm-error" data-testid={`admin-cleanup-rule-remove-${r.id}`}><X size={11} /></button>}
          </span>
        ))}
      </div>
      <form onSubmit={add} className="flex flex-wrap gap-2 mt-2">
        <select className="mm-input !w-auto" value={kind} onChange={(e) => setKind(e.target.value)} data-testid="admin-cleanup-rule-kind">
          {KINDS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
        <input className="mm-input flex-1 min-w-[140px]" placeholder="@mailinator.com" value={value} maxLength={60} onChange={(e) => setValue(e.target.value.replace(/\s/g, ""))} data-testid="admin-cleanup-rule-value" />
        <button className="mm-btn-ghost !py-2 !px-3 text-sm inline-flex items-center gap-1" disabled={value.trim().length < 2} data-testid="admin-cleanup-rule-add"><Plus size={14} /> Add rule</button>
      </form>
    </div>
  );
};
